import * as React from 'react';
export const IcTrendingFlame = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M15.62 6.54C14 5.17 13 4.27 13 3a1 1 0 00-.62-.92 1 1 0 00-1.09.21c-.1.11-2.48 2.57-.18 7.16a1.53 1.53 0 01-.1 1.83 1.09 1.09 0 01-1.25.25c-.56-.28-1.07-1.32-.76-3.39a1 1 0 00-1.54-1A8.44 8.44 0 004 14a7.83 7.83 0 008 8 7.83 7.83 0 008-8c0-3.77-2.43-5.82-4.38-7.46z'
      fill='currentColor'
    />
  </svg>
);
